<template>
	<div class="offer-flight-details-modal">
		<BaseModal
			class="offer-flight-details-modal__modal"
			:header-title="translate('offer.flight.details')"
			with-open-button
			:open-button-props="{
				label: translate('offer.flight.details'),
				bold: true,
			}"
			@open="$emit('flightDetailsModalOpen')"
		>
			<CheckoutFlightDetails
				class="offer-flight-details-modal__flight-details"
				:inbound-flight="inboundFlightSegments"
				:outbound-flight="outboundFlightSegments"
			/>
		</BaseModal>
	</div>
</template>
<script lang="ts" setup>
import type { FlightSegment } from '@/interfaces/checkout/offer-data';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import CheckoutFlightDetails from '@lmt-rpb/CheckoutFlightDetails/CheckoutFlightDetails.vue';
import { useTranslations } from 'src/storybook/src/composables/translations';
interface Props {
	inboundFlightSegments: FlightSegment[];
	outboundFlightSegments: FlightSegment[];
}
defineProps<Props>();
defineEmits(['flightDetailsModalOpen']);
const { translate } = useTranslations();
</script>
